import { myEnterpriseService } from '../../io/EnterpriseService/EnterpriseService.connected';
import { createAppScopeService } from './AppScopeService.impl';

export const myAppScopeService = createAppScopeService({
  enterpriseService: myEnterpriseService
});
